import SmoothScroll from 'smooth-scroll'

/**
 * A CTA button that scrolls the page to the element folowing it's parent.
 * @author Dayne Coulson-Hoffacker
 */
export default class ScrollBtn {
  /**
   * Constructs a new scroll button.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.scrollTarget = this.element.parentNode.nextElementSibling
    this.scroll = new SmoothScroll()
    this.scrollOptions = {
      speed: 750,
      updateURL: false
    }

    this.element.addEventListener('click', () => {
      this.scroll.animateScroll(this.scrollTarget, this.element, this.scrollOptions)
    })
  }
}



// WEBPACK FOOTER //
// ./components/scroll-btn/index.js